
import {System} from './System'
import {FileUtil} from "../lib/FileUtil";

export const Doc = {


    getListColumns() {

        const columns = [
            { field: 'displayName', headerName: 'Dokument',  type: 'string',  width: 240, sortable: true },
            { field: 'displaySize', headerName: 'Grösse',    type: 'string',  width: 120,  sortable: true},
            { field: 'displayMime', headerName: 'Typ',       type: 'string',  width: 120, sortable: true },
        ]
        columns.push(...System.getInsertSystemColumns());

        columns.push(...[
            // { field: 'project_id',      headerName: 'Project Id',   type: 'number',  width:  80, sortable: true },
            // { field: 'project_task_id', headerName: 'Task Id',      type: 'number',  width:  80, sortable: true },
            { field: 'id',              headerName: 'Doc Id',       type: 'number',  width:  80, sortable: true },
        ])

        return columns;
    },

    mapListColumns(docs) {
        return docs.map(doc => {

            const rawName = doc.label && doc.label.trim().length > 0 ? doc.label : doc.file_name;

            return {
                ...doc,
                displayName: FileUtil.extractFileName(rawName),
                displaySize: FileUtil.formatFileSize(doc.file_size),
                displayMime: FileUtil.formatMimeType(doc.mime_type)
            };
        });
    },

};

